import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const FormularioModal = ({ onClose, formulario, onFormularioAtualizado }) => {
    const [tituloModal, setTituloModal] = useState("");
    const [formData, setFormData] = useState({
        ds_formulario: ''
    });

    useEffect(() => {
        if (formulario != null) {
            setFormData({
                ...formulario,
            });
            setTituloModal('Editar Formulário');
        }
        else setTituloModal('Novo Formulário');
    }, [formulario]);

    const handleChange = (e) => {
		const { name, value } = e.target;
        
		setFormData({
			...formData,
			[name]: value
		});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.ds_formulario == '') {
            Swal.fire('Erro', 'Por favor, preencha o Nome.', 'error');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        try {
            if (formulario != null) {
                await api.put(`/anamnese-formularios/${formulario.id}`, formData);
            }
            else {
                await api.post(`/anamnese-formularios`, formData);
            }

            onFormularioAtualizado();
            onClose();
            Swal.fire('Sucesso', 'Formulário salvo com sucesso!', 'success');
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mt-3">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="ds_formulario"
                                        className="form-control"
                                        value={formData.ds_formulario}
                                        autoComplete="off"
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSubmit}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default FormularioModal;
